import type { TagData } from "@modules/bookmarks/tags/tags-api"

export type EntriesErrorResponse = {
    messageId: "string"
    message: "string"
    error: "string"
}

type EntriesSuccessResponse = {
    messageId: "string"
    message: "string"
    entries: JsonEntryData[]
}

export type JsonEntryData = {
    advertId: number
    profileId: number
    isOnline: boolean
    rating: number
    notes: string
    name: string
    locality: string
    thumbnailUrlPublic: string
    thumbnailUrlUncensored: string
    seoUrl: string
    tags: TagData[]
}

export const fetchJsonEntriesFromApi = async (userId: number): Promise<JsonEntryData[]> => {
    return fetch(`/api/bookmarks/${userId}/list`).then(async (apiResponse: Response): Promise<JsonEntryData[]> => {
        if (!apiResponse.ok) {
            throw (await apiResponse.json()) as Promise<EntriesErrorResponse>
        }

        return (await ((await apiResponse.json()) as Promise<EntriesSuccessResponse>)).entries
    })
}
